// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_ii-6";
export var emphasizeQuantity = "_ii-3";
export var flatBottomCorners = "_ii-5";
export var productImage = "_ii-0";
export var quantityContainer = "_ii-2";
export var tooltip = "_ii-1";
export var wrapAndEllipsesOverflow = "_ii-4";